<div class="session-timeout-warning-overlay">
  <div class="session-timeout-warning-dialog">
    <div class="warning-icon">
      <mat-icon>warning</mat-icon>
    </div>

    <h2 class="warning-title">Session Timeout Warning</h2>

    <p class="warning-message">
      Your session will expire due to inactivity in:
    </p>

    <div class="countdown-display">
      {{ formattedCountdown }}
    </div>

    <p class="warning-instructions">
      Click "Continue Session" to remain logged in, or you will be automatically logged out.
    </p>

    <div class="warning-actions">
      <button mat-raised-button (click)="continueSession()" class="continue-button">
        Continue Session
      </button>
    </div>
  </div>
</div>
